<template>
  <div>
    <!--    id  CN-N000102-24 -->
    <p style="font-size: 18px;color: red">每购买一套请选择3个护腰,3个护膝</p>
    <p>请选择护膝</p>
    <el-table
        border
        :data="HX_list"
        header-align="center"
        style="width: 100%">
      <el-table-column  prop="code" align="center" :label="$t('BiGoods.goodsCode')"></el-table-column>
      <el-table-column  prop="name" align="center" :label="$t('BiGoods.name')"></el-table-column>
      <el-table-column  prop="pv" align="center" :label="$t('PV')"></el-table-column>
      <el-table-column  prop="proPrice" align="center" :label="$t('pd.price')"></el-table-column>
      <el-table-column label="购买数量" prop="quantity" width="200" align="center">
        <template slot-scope="{row}">
          <el-input-number
              v-model="row.quantity"
              size="mini"
              :min="0"
              style="width:100px;"
              @change="CNN00010224_HX_Change(row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <p>请选择护腰</p>
    <el-table
        border
        :data="HY_list"
        header-align="center"
        style="width: 100%">
      <el-table-column  prop="code" align="center" :label="$t('BiGoods.goodsCode')"></el-table-column>
      <el-table-column  prop="name" align="center" :label="$t('BiGoods.name')"></el-table-column>
      <el-table-column  prop="pv" align="center" :label="$t('PV')"></el-table-column>
      <el-table-column  prop="proPrice" align="center" :label="$t('pd.price')"></el-table-column>
      <el-table-column label="购买数量" prop="quantity" width="200" align="center">
        <template slot-scope="{row}">
          <el-input-number
              v-model="row.quantity"
              size="mini"
              :min="0"
              style="width:100px;"
              @change="CNN00010224_HY_Change(row)"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "PK02624",
  data(){
    return{
      HX_list:[
        {
          name:'健康护膝(M)',
          code:'CN-T001-01-02',
          quantity: 0,
          point:0,
          price:0,
          proPrice:0,
          pv:0,
          gift:'套组内产品',
          id:-47
        },
        {
          name:'健康护膝(L)',
          code:'CN-T001-01-03',
          quantity: 0,
          point:0,
          price:0,
          proPrice:0,
          pv:0,
          gift:'套组内产品',
          id:-48
        },
        {
          name:'健康护膝(XL)',
          code:'CN-T001-01-04',
          quantity: 0,
          point:0,
          price:0,
          proPrice:0,
          pv:0,
          gift:'套组内产品',
          id:-49
        },
      ],
      HY_list:[
        {
          name:'健康磁性护腰2.0(M)',
          code:'CN-T003-01-02',
          quantity: 0,
          point:0,
          price:0,
          proPrice:0,
          pv:0,
          gift:'套组内产品是',
          id:-50
        },{
          name:'健康磁性护腰2.0(L)',
          code:'CN-T003-01-02',
          quantity: 0,
          point:0,
          price:0,
          proPrice:0,
          pv:0,
          gift:'套组内产品',
          id:-51
        },{
          name:'健康磁性护腰2.0(XL)',
          code:'CN-T003-01-02',
          quantity: 0,
          point:0,
          price:0,
          proPrice:0,
          pv:0,
          gift:'套组内产品',
          id:-52
        },{
          name:'健康磁性护腰2.0(XXL)',
          code:'CN-T003-01-02',
          quantity: 0,
          point:0,
          price:0,
          proPrice:0,
          pv:0,
          gift:'套组内产品',
          id:-53
        },
      ],
    }
  },
  props: {
    CNN00010224_num: {
      type: Number,
      default: 0
    }
  },
  watch:{
    'CNN00010224_num': function (val) {
      if(val===0){
        this.PK02624_HX_list[0].quantity = 0
        this.PK02624_HX_list[1].quantity = 0
        this.PK02624_HX_list[2].quantity = 0
        this.PK02624_HY_list[0].quantity = 0
        this.PK02624_HY_list[1].quantity = 0
        this.PK02624_HY_list[2].quantity = 0
        this.PK02624_HY_list[3].quantity = 0
      }
    },
  },
  methods:{
    CNN00010224_HX_Change(){
      let num = 0
      this.HX_list.forEach(v=>{
        num += v.quantity
      })
      if(num !== this.CNN00010224_num*3){
        // this.$message.error('护膝所选尺码数量与购买套组数量不符')
        console.log('护膝所选尺码数量与购买套组数量不符')
      }
      // console.log(num,11111,this.PK02624_num*6)
      this.$emit('CNN00010224_HX_Change', this.HX_list)
    },
    CNN00010224_HY_Change(){
      let num = 0
      this.HY_list.forEach(v=>{
        num += v.quantity
      })
      if(num !== this.CNN00010224_num*3){
        // this.$message.error('护腰所选尺码数量与购买套组数量不符')
        console.log('护腰所选尺码数量与购买套组数量不符')
      }
      this.$emit('CNN00010224_HY_Change', this.HY_list)
    },
  }
}
</script>

<style scoped>

</style>
